__webpack_require__.p = "https://images-cdn-staging.curipod.com/d-bb6d0ddd/_next/";